import { Injectable } from '@nestjs/common';
import { UserService } from '../user/user.service';
import { JwtService } from '@nestjs/jwt';
import { JwtPayload } from './jwt.payload';
import { updateUserDto, UpdateUserDto, UserDto } from '../user/dto/user.dto';
import { CreateUserDto, LoginUserDto } from '../user/dto/user.dto';
import { RegistrationStatus } from '../user/dto/registraton.dto';
import { UserResponseModel, UserStatusWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { LoginResponse, JwtTokenModel, UserAuthResponse, LoginUserModel } from '@gtpl/shared-models/common-models';

import { UserEntity } from '../user/user.entity';
import { InjectRepository } from '@nestjs/typeorm';
import { Repository } from 'typeorm';
import { UserRequest } from '../user/dto/user.request';
import appSettings from 'apps/services/config';
import { getManager } from 'typeorm';
@Injectable()
export class AuthService {
  constructor(
    //  @InjectRepository(UserEntity)
    private readonly userService: UserService,
    private readonly jwtService: JwtService,
    // private readonly userRepo: Repository<UserEntity> 
  ) { }

  async validateUser(payload: JwtPayload): Promise<UserDto> {
    const user = await this.userService.findByPayload(payload);
    if (!user) {
      throw 'new HttpException(Invalid token, HttpStatus.UNAUTHORIZED)';
    }
    return user;
  }

  findUser(employeeId: number) {
    return this.userService.findOne({ employeeId });
  }

  async register(userDto: CreateUserDto): Promise<RegistrationStatus> {
    let status: RegistrationStatus = {
      success: true,
      message: 'user registered',
    };
    try {
      // console.log(userDto);
      await this.userService.create(userDto);
    } catch (err) {
      status = {
        success: false,
        message: err,
      };
    }
    return status;
  }
  // async updateUser(userDto: updateUserDto): Promise<RegistrationStatus> {
  //   let status: RegistrationStatus = {
  //       success: true,   
  //       message: 'user updated',
  //   };
  //   try {
  //     await this.userService.update(userDto);
  //   } catch (err) {
  //       status = {
  //           success: false,        
  //           message: err,
  //       };    
  //   }
  //   return status;  
  // }
  async login(loginUserDto: LoginUserDto): Promise<LoginResponse> {
    // find user in db    
    try {
      const user: LoginUserModel = await this.userService.findByLogin(loginUserDto);
      console.log(user);
      const manager = getManager()
      const unitcodesTable  = `select plant_type as plantType from ${appSettings.masters_db}.unitcodes where unit_code_id = ${user.unitId}`
      const data = await manager.query(unitcodesTable)
      user.plantType = data[0].plantType;
      const obj = {plantType:data[0].plantType,...user}

      // generate and sign token    
      const token: JwtTokenModel = await this._createToken(user);
      return {
        // username:user.username,
        status: true,
        user_data: obj, 
        jwt: token,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  // private _createToken({ username }: UserDto): JwtTokenModel {
  //   const user: JwtPayload = { username };
  //   const accessToken: string = this.jwtService.sign(user);
  async _createToken(userData:LoginUserModel): Promise<any> {
    const payload = { username: userData.username, sub: userData.id };
    const accessToken = await this.jwtService.signAsync(payload);
    console.log(accessToken,'accesstoken');
    return {
      expiresIn: '1h',//process.env.EXPIRESIN,
      accessToken: accessToken,
    };
  }
  async getAllUsers(): Promise<any> {
    const users = await this.userService.getAllUsers();
    return users;
  }

  async updateUser(userDto: updateUserDto): Promise<RegistrationStatus> {
    console.log(userDto);
    let status: RegistrationStatus = {
      success: true,
      message: 'user updated',
    };
    try {
      await this.userService.update(userDto);
    } catch (err) {
      status = {
        success: false,
        message: err,
      };
      console.log(err);
    }
    return status;
  }
  async activateOrDeactivateUser(userReq: UserRequest): Promise<UserResponseModel> {
    //   console.log(State.stateCode);
    const users = await this.userService.activateOrDeactivateUser(userReq);
    return users;
  }
  // async getActiveUsersCount():Promise<UserStatusWiseResponseModel>{
  //   const users=await this.userService.getActiveUsersCount();
  //   return users;
  // }

  async getAllActiveUser(): Promise<any> {
    const users = await this.userService.getAllActiveUser();
    return users;
  }


  /**
   * gets the active user by the given UID
   * @param userId 
   * @returns 
   */
  async getActiveUserById(userId: string): Promise<UserAuthResponse> {
    const userInfo: LoginUserModel = await this.userService.getActiveUserById(userId);
    return new UserAuthResponse(true, 0, 'User retrieved successfully', userInfo);
  }
}
